import { actions, mutations } from "@/constants/state";
import { getEnabled } from "@/services/user-service";

export default {
  [actions.USERS_ENABLED_FETCH_ACTION]: async ({ commit }) => {
    const { data } = await getEnabled();
    commit(mutations.USERS_ENABLED_FETCH_MUTATION, data);
  },
};
